// extracted by mini-css-extract-plugin
export default {"icon":"InfoTooltip_icon__mMCOz","small":"InfoTooltip_small__3pjIP","medium":"InfoTooltip_medium__zcG2V","tooltipText":"InfoTooltip_tooltipText__pZkWK"};